import { useMemo } from "react";

import { defineMessage, useIntl } from "react-intl";

import { MobileNavCardProps } from "./mobile-nav-card";
import { MobileNavMenuPage, LinkSection } from "./mobile-nav-menu-page";

export const MobileNavTeams = () => {
    const intl = useIntl();

    function useResourcesData(): Array<MobileNavCardProps> {
        return useMemo(() => {
            return [
                {
                    key: "software",
                    href: "/teams/software-development",
                    name: intl.formatMessage(
                        defineMessage({
                            id: "globalnavv2.subnav.teams.software.title",
                            defaultMessage: "Software"
                        })
                    ),
                    description: intl.formatMessage(
                        defineMessage({
                            id: "globalnavv2.subnav.teams.software.content",
                            defaultMessage:
                                "Ship high-quality, innovative software faster"
                        })
                    )
                },
                {
                    key: "marketing",
                    href: "/teams/marketing",
                    name: intl.formatMessage(
                        defineMessage({
                            id: "globalnavv2.subnav.teams.marketing.title",
                            defaultMessage: "Marketing"
                        })
                    ),
                    description: intl.formatMessage(
                        defineMessage({
                            id: "globalnavv2.subnav.teams.marketing.content",
                            defaultMessage:
                                "Collaborative strategies for marketing success"
                        })
                    )
                },
                {
                    key: "project-management",
                    // TODO: FIGURE OUT LINK
                    href: "#",
                    name: intl.formatMessage(
                        defineMessage({
                            id: "globalnavv2.subnav.teams.projectmanagement.title",
                            defaultMessage: "Project management"
                        })
                    ),
                    description: intl.formatMessage(
                        defineMessage({
                            id: "globalnavv2.subnav.teams.projectmanagement.content",
                            defaultMessage:
                                "Plan, track, and optimize projects for smooth delivery"
                        })
                    )
                },
                {
                    key: "design",
                    // TODO: FIGURE OUT LINK
                    href: "#",
                    name: intl.formatMessage(
                        defineMessage({
                            id: "globalnavv2.subnav.teams.design.title",
                            defaultMessage: "Design"
                        })
                    ),
                    description: intl.formatMessage(
                        defineMessage({
                            id: "globalnavv2.subnav.teams.design.content",
                            defaultMessage:
                                "Align on user needs and craft breathtaking experiences"
                        })
                    )
                },
                {
                    key: "product-management",
                    // TODO: FIGURE OUT LINK
                    href: "#",
                    name: intl.formatMessage(
                        defineMessage({
                            id: "globalnavv2.subnav.teams.productmanagement.title",
                            defaultMessage: "Product management"
                        })
                    ),
                    description: intl.formatMessage(
                        defineMessage({
                            id: "globalnavv2.subnav.teams.productmanagement.content",
                            defaultMessage:
                                "Master the product lifecycle, from brainstorm to launch"
                        })
                    )
                },
                {
                    key: "see-all-teams",
                    // TODO: FIGURE OUT LINK
                    href: "#",
                    name: intl.formatMessage({
                        id: "globalnavv2.subnav.teams.allteams",
                        defaultMessage: "See all teams"
                    })
                }
            ];
        }, []);
    }

    function useResourcesLinks(): Array<LinkSection> {
        return useMemo(() => {
            return [
                {
                    key: "solution",
                    name: intl.formatMessage(
                        defineMessage({
                            id: "globalnavv2.subnav.teams.links.solution",
                            defaultMessage: "Solution"
                        })
                    ),
                    links: [
                        {
                            key: "work-management",
                            text: intl.formatMessage(
                                defineMessage({
                                    id: "globalnavv2.subnav.teams.links.work-management",
                                    defaultMessage: "Work Management"
                                })
                            ),
                            href: "/solutions/work-management"
                        },
                        {
                            key: "it-service-management",
                            text: intl.formatMessage(
                                defineMessage({
                                    id: "globalnavv2.subnav.teams.links.it-service-management",
                                    defaultMessage: "IT Service Management"
                                })
                            ),
                            href: "/solutions/itsm"
                        },
                        {
                            key: "agile-devops",
                            text: intl.formatMessage(
                                defineMessage({
                                    id: "globalnavv2.subnav.teams.links.agile-devops",
                                    defaultMessage: "Agile & DevOps"
                                })
                            ),
                            href: "/solutions/devops"
                        }
                    ]
                },
                {
                    key: "byTeamSize",
                    name: intl.formatMessage(
                        defineMessage({
                            id: "globalnavv2.subnav.teams.links.by-team-size",
                            defaultMessage: "By Team Size"
                        })
                    ),
                    links: [
                        {
                            key: "enterprise",
                            text: intl.formatMessage(
                                defineMessage({
                                    id: "globalnavv2.subnav.teams.links.enterprise",
                                    defaultMessage: "Enterprise"
                                })
                            ),
                            href: "/enterprise"
                        },
                        {
                            key: "small-business",
                            text: intl.formatMessage(
                                defineMessage({
                                    id: "globalnavv2.subnav.teams.links.small-business",
                                    defaultMessage: "Small Business"
                                })
                            ),
                            href: "/software/small-business"
                        },
                        {
                            key: "startup",
                            text: intl.formatMessage(
                                defineMessage({
                                    id: "globalnavv2.subnav.teams.links.startup",
                                    defaultMessage: "Startup"
                                })
                            ),
                            href: "/software/startups"
                        },
                        {
                            key: "non-profit",
                            text: intl.formatMessage(
                                defineMessage({
                                    id: "globalnavv2.subnav.teams.links.non-profit",
                                    defaultMessage: "Non-profit"
                                })
                            ),
                            href: "/teams/nonprofits"
                        }
                    ]
                },
                {
                    key: "byIndustry",
                    name: intl.formatMessage(
                        defineMessage({
                            id: "globalnavv2.subnav.teams.links.by-industry",
                            defaultMessage: "By Industry"
                        })
                    ),
                    links: [
                        {
                            key: "retail",
                            text: intl.formatMessage(
                                defineMessage({
                                    id: "globalnavv2.subnav.teams.links.retail",
                                    defaultMessage: "Retail"
                                })
                            ),
                            href: "/industries/retail"
                        },

                        {
                            key: "telecommunications",
                            text: intl.formatMessage(
                                defineMessage({
                                    id: "globalnavv2.subnav.teams.links.telecommunications",
                                    defaultMessage: "Telecommunications"
                                })
                            ),
                            href: "/industries/telecom"
                        },
                        {
                            key: "professional-services",
                            text: intl.formatMessage(
                                defineMessage({
                                    id: "globalnavv2.subnav.teams.links.professional-services",
                                    defaultMessage: "Professional services"
                                })
                            ),
                            href: "/industries/professional-services"
                        },
                        {
                            key: "government",
                            text: intl.formatMessage(
                                defineMessage({
                                    id: "globalnavv2.subnav.teams.links.government",
                                    defaultMessage: "Government"
                                })
                            ),
                            href: "/government"
                        }
                    ]
                }
            ];
        }, []);
    }

    const resourcesData = useResourcesData();
    const resourcesLinks = useResourcesLinks();

    return (
        <MobileNavMenuPage
            pageLabel={intl.formatMessage({
                id: "globalnav.v2.teams.title",
                defaultMessage: "Teams"
            })}
            cards={resourcesData}
            linksSections={resourcesLinks}
        />
    );
};
